import { useTheme } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import Box from "@subly/s1/ui/atom/Box";
import Form from "@subly/s1/ui/atom/Form";

import Icon from "ui/icon";
import { useWelcomePricing } from "../fabric";
import Actions from "./Actions";


export default function Pricing() {
	const { form } = useWelcomePricing();
	const theme = useTheme();

	const style = {
		card: {
			flexWrap: "wrap",
			alignItems: "flex-start",
			border: `1px solid ${theme.palette.divider}`,
			borderRadius: 2,
			p: 2, gap: 5
		},
		settingRow: {
			borderTop: `1px solid ${theme.palette.divider}`,
			py: 1,
			justifyContent: "space-between",
			alignItems: "center"
		},
		preview: { flex: "1 1 240px", textAlign: "center" }
	} satisfies SxProps;

	return (
		<Form>
			<form.AppForm>
				<Box sx={style.card}>
					<Box.Column gap={1.25} sx={{ flex: "1 1 240px" }}>
						<form.AppField name="articlePrice">
							{(field) => <field.Input label="Default Article Price" type="number" endAdornment={<Icon name="coin" />} required />}
						</form.AppField>
						<form.Subscribe selector={(state) => state.values.pass.enabled}>
							{(enabled) => (
								<>
									<Box sx={style.settingRow}>
										<Box.Column>
											<Typography variant="body3" color="text.secondary">Enable Time Pass</Typography>
											<Typography variant="body2" fontWeight={700} color="secondary">{enabled ? "Enabled" : "Disabled"}</Typography>
										</Box.Column>
										<form.AppField name="pass.enabled">
											{(field) => <Switch color="secondary" checked={enabled} onChange={(e) => field.handleChange(e.target.checked)} />}
										</form.AppField>

									</Box>
									<Form.Row sx={{ alignItems: "flex-start" }}>
										<form.AppField name="pass.price">
											{(field) => <field.Input label="Pass Price" type="number" disabled={!enabled} endAdornment={<Icon name="coin" />} required={enabled}/> }
										</form.AppField>
										<form.AppField name="pass.duration">
											{(field) => <field.Input label="Pass Duration" type="number" disabled={!enabled} endAdornment={<Typography variant="body2" color="text.secondary">Days</Typography>} required={enabled} />}
										</form.AppField>
									</Form.Row>
								</>
							)}
						</form.Subscribe>
					</Box.Column>
					<Box.Column gap={1.25} sx={style.preview}>
						<Typography variant="h4">How your Subly bands will look</Typography>
						<Box id="subly-ui" />
					</Box.Column>
				</Box>
				<form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
					{([canSubmit, isSubmitting]) => <Actions canSubmit={canSubmit} isSubmitting={isSubmitting} onClick={form.handleSubmit} />}
				</form.Subscribe>
			</form.AppForm>
		</Form>
	);
}